import React from "react";
import { FiShield, FiZap, FiUsers, FiTrendingUp, FiLayers, FiGlobe, FiImage, FiCpu } from "react-icons/fi";
import { SiEthereum, SiSolidity, SiPolygon, SiChainlink, SiIpfs, SiFirebase } from "react-icons/si";
import { LuSettings, LuUsers, LuSearch, LuSmartphone, LuShieldCheck, LuPercent, LuShield, LuCpu, LuClipboardList, LuCode, LuBug, LuRocket, LuWallet } from "react-icons/lu";

// 1. Hero Block Configuration
export const blockHeroData = {
  backgroundImage: "/images/serviceBanners/blockchainTechnologyBanner.webp",
  whiteImage: "/images/serviceBanners/BitccoinW.webp",
  subTitle: "Secure & Scalable Blockchain Solutions",
  title: (
    <>
      Building the <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">Decentralized Future</span> with Blockchain Solutions
    </>
  ),
  description:
    "We build secure, scalable, and high performance blockchain solutions that power decentralized applications, smart contracts, and transparent ecosystems to enhance trust, security, and efficiency in modern digital business operations.",
  primaryButton: {
    title: "Get Started",
    onClick: () => console.log("Blockchain Start clicked"),
  },
  secondaryButton: {
    title: "View Our Work",
    onClick: () => console.log("Blockchain Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "High Performance",
      desc: "Fast and optimized blockchain solutions.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Responsive Design",
      desc: "Works smoothly across all devices and platforms.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Secure & Reliable",
      desc: "Strong security with trusted blockchain architecture.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Clean Code",
      desc: "Simple, maintainable and developer-friendly code structure.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/nodejs.webp",
      top: "16%",
      right: "6%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
  ],
};

// 2. Stats Block
export const blockStatsData = [
  {
    icon: LuSettings,
    value: "150+",
    label: "Apps Built",
    colorClass: "text-[#00d2ff]",
    bgClass: "bg-[#00d2ff]/10",
    borderClass: "border-[#00d2ff]/20",
    glowClass: "shadow-[0_0_20px_rgba(0,210,255,0.15)]",
  },
  {
    icon: LuUsers,
    value: "90+",
    label: "Happy Clients",
    colorClass: "text-[#a855f7]",
    bgClass: "bg-[#a855f7]/10",
    borderClass: "border-[#a855f7]/20",
    glowClass: "shadow-[0_0_20px_rgba(168,85,247,0.15)]",
  },
  {
    icon: LuSmartphone,
    value: "50M+",
    label: "Downloads",
    colorClass: "text-[#06b6d4]",
    bgClass: "bg-[#06b6d4]/10",
    borderClass: "border-[#06b6d4]/20",
    glowClass: "shadow-[0_0_20px_rgba(6,182,212,0.15)]",
  },
  {
    icon: LuShieldCheck,
    value: "99.9%",
    label: "Crash-Free Apps",
    colorClass: "text-[#3b82f6]",
    bgClass: "bg-[#3b82f6]/10",
    borderClass: "border-[#3b82f6]/20",
    glowClass: "shadow-[0_0_20px_rgba(59,130,246,0.15)]",
  },
  {
    icon: LuPercent,
    value: "40%",
    label: "Faster Development",
    colorClass: "text-[#d946ef]",
    bgClass: "bg-[#d946ef]/10",
    borderClass: "border-[#d946ef]/20",
    glowClass: "shadow-[0_0_20px_rgba(217,70,239,0.15)]",
  },
  {
    icon: LuShield,
    value: "100%",
    label: "Client Satisfaction",
    colorClass: "text-[#6366f1]",
    bgClass: "bg-[#6366f1]/10",
    borderClass: "border-[#6366f1]/20",
    glowClass: "shadow-[0_0_20px_rgba(99,102,241,0.15)]",
  },
];

export const blockSolutionsAndProcessData = {
  buildSubtitle: "OUR EXPERTISE",
  buildTitle: "Custom Blockchain Development Solutions for Every Business Need",
  buildCards: [
    {
      title: "Scalable Blockchain Solutions",
      desc: "Build fast and secure decentralized systems for business growth.",
      icon: FiCpu,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "Enterprise Blockchain Development",
      desc: "Develop secure and scalable blockchain systems for large organizations.",
      icon: FiShield,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "E-Commerce Blockchain Solutions",
      desc: "Enable transparent and secure digital transaction systems.",
      icon: FiGlobe,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "On-Demand Blockchain Systems",
      desc: "Build real-time decentralized applications for service-based platforms.",
      icon: FiImage,
      colorClass: "text-[#34d399]",
      bgClass: "bg-[#34d399]/10",
      borderClass: "border-[#34d399]/20 hover:border-[#34d399]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(52,211,153,0.25)]",
    },
    {
      title: "FinTech Blockchain Solutions",
      desc: "Develop secure financial systems powered by blockchain technology.",
      icon: FiCpu,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "Custom Blockchain Development",
      desc: "Tailored blockchain solutions based on business goals and use cases.",
      icon: FiGlobe,
      colorClass: "text-[#f59e0b]",
      bgClass: "bg-[#f59e0b]/10",
      borderClass: "border-[#f59e0b]/20 hover:border-[#f59e0b]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(245,158,11,0.25)]",
    },
  ],
  processSubtitle: "OUR METHODOLOGY",
  processTitle: "Blockchain Development Process",
  processSteps: [
    { step: "01", title: "Discovery & Consultation", description: "Understand business goals, target audience, and blockchain requirements.", icon: LuSearch },
    { step: "02", title: "Strategy & Planning", description: "Define architecture, use cases, and development roadmap.", icon: LuClipboardList },
    { step: "03", title: "UI/UX Design", description: "Create intuitive interfaces for decentralized applications.", icon: LuShield },
    { step: "04", title: "Development", description: "Build secure and scalable blockchain solutions with clean architecture.", icon: LuCode },
    { step: "05", title: "Quality Testing", description: "Test security, performance, and smart contract reliability.", icon: LuBug },
    { step: "06", title: "Deployment & Support", description: "Launch blockchain systems and provide ongoing updates and maintenance.", icon: LuRocket },
  ],
  benefitsSubtitle: "WHY CHOOSE OUR BLOCKCHAIN DEVELOPMENT SERVICES?",
  benefitsTitle: "Why Businesses Choose Blockchain Solutions",
  benefits: [
    "Faster blockchain development",
    "Secure decentralized systems",
    "Modern user interface integration",
    "Smooth application performance",
    "Efficient development workflow",
    "Scalable blockchain architecture",
  ],
  logoImage: "/images/serviceBanners/blockchainTechnologyBanner.webp",
  whiteLogoImage: "/images/serviceBanners/BitccoinW.webp",
};

// 4. Portfolio Data
export const blockPortfolioData = {
  subtitle: "SUCCESS STORIES",
  title: "Protocols Powering the Web3 Economy",
  buttonText: "View Case Studies",
  buttonLink: "#",
  apps: [
    {
      title: "DeFi Exchange Alpha",
      badge: "DEX Protocol",
      badgeColor: "bg-[#a855f7]/10 text-[#a855f7] border-[#a855f7]/20",
      desc: "A high-performance automated market maker with cross-chain liquidity pools.",
      downloads: "Active",
      rating: "5.0",
      image: "/images/blockChain/DeFi-Protocol-Design.webp",
    },
  ],
};

// 5. Technologies Data
export const blockTechnologiesData = {
  techTitle: "OUR WEB3 TOOL STACK",
  technologies: [
    { name: "Solidity", icon: "Code" },
    { name: "Rust", icon: "Dart" },
    { name: "Ethereum", icon: "RestAPI" },
    { name: "Polygon", icon: "Provider" },
    { name: "Chainlink", icon: "Vite" },
    { name: "IPFS", icon: "Firebase" },
  ],
  trustTitle: "TRUSTED BY WEB3 LEADERS",
  trustClients: [
    { image: "/images/logo/google_logo.png", alt: "google" },
    { image: "/images/logo/microsoft_logo.png", alt: "microsoft" },
    { image: "/images/logo/amazon_logo.png", alt: "amazon" },
    { image: "/images/logo/Adobe_Corporate_logo.png", alt: "adobe" },
    { image: "/images/logo/IBM_logo.png", alt: "ibm" },
    { image: "/images/logo/Oracle_logo.png", alt: "oracle" },
  ],
};

// 6. About Overview
export const blockAboutData = [
  {
    title: "Blockchain Development Services for Secure Digital Transformation",
    content: (
      <>
        Businesses are increasingly exploring decentralized technologies to improve transparency, security, and operational efficiency. Reliable{" "}
        <b className="text-text-primary font-semibold">blockchain development services</b> help organizations build secure digital ecosystems that support trusted transactions and
        improved data integrity. Many companies struggle with outdated systems that limit scalability and create security concerns. At{" "}
        <b className="text-text-primary font-semibold">Tycho Technologies</b>, blockchain frameworks are developed around real business objectives, helping brands adopt
        future-ready technology solutions designed for long-term growth and operational reliability.
      </>
    ),
  },
  {
    title: "Blockchain App Development Company for Scalable Solutions",
    content: (
      <>
        Modern businesses require flexible digital systems that can adapt to changing market demands and improve operational trust. A trusted{" "}
        <b className="text-text-primary font-semibold">blockchain app development company</b> helps organizations build decentralized applications that support secure workflows and
        greater transparency. Companies investing in <b className="text-text-primary font-semibold">smart contract development services</b> often improve efficiency by reducing
        manual processes and enabling automated agreements with higher reliability. Tycho Technologies focuses on practical blockchain strategies designed to improve usability
        while supporting scalable business growth.
      </>
    ),
  },
  {
    title: "Web3 Software Development for Smarter Ecosystems",
    content: (
      <>
        The growth of decentralized platforms has increased the need for technology systems that support ownership, transparency, and secure digital interactions. Effective{" "}
        <b className="text-text-primary font-semibold">web3 software development</b> helps businesses build stronger digital ecosystems while improving customer trust and
        engagement. Organizations exploring decentralized innovation often strengthen technical capabilities through an{" "}
        <a href="https://tychotechnologies.com/ar-app-development-services-india/" className="text-cyan-400 underline hover:text-cyan-300">
          ar app development company
        </a>{" "}
        solutions to create more immersive and future-focused digital experiences.
      </>
    ),
  },
  {
    title: "Why Businesses Choose a Blockchain Development Company in India",
    content: (
      <>
        The demand for a trusted <b className="text-text-primary font-semibold">blockchain development company in india</b> continues to grow as organizations seek secure and
        scalable technology solutions. Businesses investing in <b className="text-text-primary font-semibold">web3 development services india</b> often prioritize flexibility,
        transparency, and stronger digital infrastructure for long-term success. Businesses partnering with Tycho Technologies gain access to tailored blockchain frameworks
        designed around measurable goals and industry requirements. Many organizations also improve intelligent automation through{" "}
        <a href="https://tychotechnologies.com/ai-ml-development-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          AI software development services
        </a>{" "}
        to strengthen innovation and business efficiency.
      </>
    ),
  },
];

// 7. FAQs
export const blockFaqs = [
  {
    q: "Why choose blockchain development services in India?",
    a: "Blockchain development in India offers access to top-tier developers and cost-effective models while adhering to global security and compliance standards.",
  },
  {
    q: "Do you offer post-launch support?",
    a: "Yes. We provide 6–12 months of free maintenance, upgrades, and continuous security monitoring for all projects.",
  },
];
